module.exports = __webpack_public_path__ + "78d98c6497b628c1169d315605f54eaf.png";